import { useAppTranslation } from '@hooks';
import { Controller, useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { CommonFilters, StateCheckbox } from '@components/inputs';
import { ContributorTypeType, UserActivityState } from '@definitions';
import { GetSuppliersPayloadType } from '@api';
import { SelectSegments } from '@views/shared/segment';
import {
  Button,
  FormItem,
  SelectOption,
  SelectInput,
  Form,
} from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';

type FiltersContributorsPropsType = {
  visible: boolean
  onClose?: () => void
  onParamsChange: (params: GetSuppliersPayloadType) => void
};
const FiltersContributors = ({
  visible,
  onClose,
  onParamsChange,
}: FiltersContributorsPropsType) => {
  const { translate } = useAppTranslation();
  const { handleSubmit, control } = useForm<GetSuppliersPayloadType>({
    defaultValues: { model: {} },
  });
  const onSubmit = (data: GetSuppliersPayloadType) => {
    onParamsChange && onParamsChange(data);
    onClose();
    return data;
  };

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form
        onReset={() => {
          control._reset();
          onSubmit({ model: {} });
        }}
        onFinish={handleSubmit(onSubmit)}
        css={drawerContentStyle}
      >
        <CommonFilters control={control} />

        <Controller
          name={'model.type'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.role')}>
              <SelectInput
                mode={'multiple'}
                value={field.value}
                onChange={field.onChange}
                css={fullWidthStyle}
              >
                {Object.entries(ContributorTypeType).map(([id, label]) => (
                  <SelectOption key={id} value={Number(id)}>
                    {label}
                  </SelectOption>
                ))}
              </SelectInput>
            </FormItem>
          )}
        />
        <Controller
          name={'model.activity'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.state')}>
              <StateCheckbox
                values={UserActivityState}
                labelTxKey={'userActivity'}
                preset={'user-status'}
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
              />
            </FormItem>
          )}
        />
        <Controller
          name={'model.segments'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.segments')}>
              <SelectSegments onChange={field.onChange} value={field.value} />
            </FormItem>
          )}
        />

        {/*<FormItem label="Performance">*/}
        {/*	<ProgressBar*/}
        {/*		{...register("model.performance")}*/}
        {/*		min={0}*/}
        {/*		range={true}*/}
        {/*		max={100}*/}
        {/*		tooltipVisible={true}*/}
        {/*		defaultValue={[25, 75]}*/}
        {/*		// @ts-ignore*/}
        {/*		css={css`*/}
        {/*			margin-top: 60px;*/}
        {/*		`}*/}
        {/*	/>*/}
        {/*</FormItem>*/}

        <FiltersDrawerFooter>
          <Button htmlType="reset">{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

const drawerContentStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const fullWidthStyle = css`
  width: 100%;
`;

export default FiltersContributors;
